<template>
  <div class="public_benefit_index">
    <div class="tab_list">
      <div class="tab_list_block training" @click="toTrain('/train')">
        <div class="training_icon"></div>
        <div class="title">师资培训</div>
      </div>
      <div class="tab_list_block lecture" @click="toAttend()">
        <div class="lecture_icon"></div>
        <div class="title">幼儿足球课程</div>
      </div>
      <div class="tab_list_block test" @click="toJump('/test')">
        <div class="test_icon"></div>
        <div class="title">幼儿足球测试体系</div>
      </div>
      <div class="tab_list_block sports" @click="toJump('/sport')">
        <div class="sports_icon"></div>
        <div class="title">小小运动会</div>
      </div>
    </div>
    <div class="video_title_block">
      <div class="title_component">
        <div class="bar_one"></div>
        <div class="bar_two"></div>
        <div class="title">公益园视频</div>
        <div class="bar_two"></div>
        <div class="bar_one"></div>
      </div>
      <div class="btns">
        <div class="search">
          <input
            autocomplete="new-password"
            v-model="searchKey"
            style="height: 100%"
          />
          <span class="icon" @click="handleSearch"></span>
        </div>
        <div class="upload tab" @click="alertShow = true">我要上传</div>
      </div>
    </div>
    <div class="video_block">
      <div
        class="video_block_item tab"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetail(item)"
      >
        <div
          class="video_player_block"
          :style="{
            backgroundImage:
              'url(' + constant.URL + '/' + item.coverimage + ')',
          }"
        >
          <div class="hover">
            <div class="icon" v-show="item.uploadertype == 0">官方</div>
            <div class="player_icon"></div>
            <div class="alert_info">
              <div class="eye">
                <span class="eye_icon"></span>
                <span class="eye_title">{{ item.play_count }}</span>
              </div>
              <div class="msg">
                <span class="msg_icon"></span>
                <span class="msg_title">{{ item.comment_count }}</span>
              </div>
            </div>
            <div class="title">{{ item.name }}</div>
            <div class="fire"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_more tab" @click="handleParamsSearch"></div>

    <div class="alert_block" v-show="alertShow">
      <div class="block" v-loading="loading">
        <div class="left">
          <div class="dot"></div>
        </div>
        <div class="right">
          <div class="file_upload_block">
            <div>
              <div class="btn">上传封面</div>
              <el-upload
                :headers="{ token: $store.state.userInfo.token }"
                class="avatar-uploader"
                :action="constant.UPLOAD_URL + '/file/upload'"
                :show-file-list="false"
                :before-upload="beforeAvatarImg"
                :on-success="handleAvatarSuccess"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div>
              <div class="btn">上传视频</div>
              <input type="text" v-model="videoUrl" readonly="true" />
              <el-upload
                ref="upload"
                :headers="{ token: $store.state.userInfo.token }"
                class="upload-demo"
                :data="{
                  title: '11111',
                }"
                :action="constant.UPLOAD_URL + '/vod/video/ossUploadVideo'"
                :on-success="handleVideoSuccess"
                :before-upload="beforeAvatarUpload"
                :show-file-list="false"
              >
                <el-button class="upload_btn" type="primary"
                  >点击上传</el-button
                >
              </el-upload>
            </div>
            <div>
              <div class="btn">标题</div>
              <input type="text" v-model="titleName" />
            </div>
          </div>
          <div class="submit" @click="addVideoUrl" style="cursor: pointer">
            确定
          </div>
        </div>
        <div class="del tab" @click="alertShow = false"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "publicBenefit",
  components: {},
  data() {
    return {
      loading: false,
      titleName: "", //上传文件名
      alertShow: false,
      imageUrl: "",
      videoUrl: "",
      list: [],
      searchKey: "", // 关键字
      params: {
        page: 0,
        size: 10,
      },
    };
  },
  mounted() {
    this.search();
    // console.log(this.constant);
  },
  methods: {
    beforeAvatarUpload(file) {
      //限制上传视频处理函数
      let type1 = file.name.substring(file.name.lastIndexOf(".") + 1);
      let type = type1.trim().toLowerCase();
      const isvideo = type === "mp4";

      const isLt50M = file.size / 1024 / 1024 < 30;
      if (isvideo) {
        if (!isLt50M) {
          this.$message.error("上传视频大小不能超过 30MB!");
          this.$refs.upload.clearFiles();
        } else {
          this.loading = true;
        }
      } else {
        this.$message.error("只能上传MP4格式");
      }
    },
    beforeAvatarImg(file){
      const isJPG = file.type === 'image/jpeg';
      if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
    },
    // 视频确认提交
    addVideoUrl() {
      var data = {
        projecttype: "1",
        annextype: "2",
        schoolid: this.$store.state.userInfo.schoolId,
        role: this.$store.state.userInfo.userId,
        uploader: this.$store.state.userInfo.userId,
        url: this.videoUrl,
        uploadertype: "1",
        savepath: this.videoUrl,
        coverimage: this.imageUrl.split("com")[1],
        name: this.titleName,
      };
     
     if(!this.titleName) {
       this.$notice({
         message:"标题不能为空"
       }).isShow()
       return
     }
     if(!this.imageUrl) {
       this.$notice({
         message:"请上传封面"
       }).isShow()
       return
     }
     if(!this.videoUrl) {
       this.$notice({
         message:"请上传视频"
       }).isShow()
       return
     }

      if (this.titleName && this.imageUrl && this.videoUrl) {
        this.api.publicBenefit.annex(data).then((res) => {
          if (res.code === 20000) {
            this.$notice({
              type: "success",
              message: "上传成功",
            }).isShow();
            this.alertShow = false;
          } else {
            this.$notice({
              message: res.message,
            }).isShow();
          }
        });
      }
      data = {};
    },
    search() {
      this.api.publicBenefit
        .searchAnnex({
          key: this.searchKey,
          uid: this.$store.state.userInfo.userId || 0,
          page: this.params.page,
          size: this.params.size,
        })
        .then((res) => {
          this.list = this.list.concat(...res.data);
        });
    },
    handleAvatarSuccess(res) {
      // console.log(res);
      this.imageUrl = res.data.url;
    },
    handleVideoSuccess(res) {
      if (res.data) {
        this.videoUrl = res.data;
        this.loading = false;
      }
      // console.log(res, file);
    },
    // 师资力量跳转
    toTrain(val){
      if(val === "/train") {
        this.$router.push({
          path: val,
          query: {
            welfareTrain: "welfareTrain",
          },
        });
      }
    },
    // 公益视频查看
    toDetail(item) {
      //判断是否登录
      // if (!this.$store.state.userInfo.token) {
      //   this.$store.commit("setLoginState", "login");
      //   return;
      // }
      this.$router.push({
        path: "/publicBenefitDetail",
        query: {
          ...item,
        },
      });
    },
    toJump(val) {
      
      if (val ==="/test") {
        this.$router.push({
          path: val,
          query: {
            welfareTest: "welfareTest",
          },
        });
      }else {
        this.$router.push({
        path: val,
      });
      }
      
    },
    toAttend() {
      let path = "";
      if (this.$store.state.userInfo.teacherId) {
        path = "/attendClass";
      } else {
        path = "/course_class";
      }
      this.$router.push({
        path,
        query: {
          welfare: "welfare",
        },
      });
      // this.api.park
      //   .invoiceType({ schoolId: this.$store.state.userInfo.schoolId })
      //   .then((res) => {
      //     // this.phone = res.data.mobile.slice(1);
      //     if (res.code) {
      //       if (res.data !== 5) {
      //         this.$notice({
      //           message: "仅公益园用户使用",
      //         }).isShow();
      //       } else {

      //       }
      //     }
      //   });
    },
    handleParamsSearch() {
      this.params.page = this.params.page + 1;
      this.search();
    },
    handleSearch() {
      this.list = [];
      this.params = {
        page: 0,
        size: 10,
      };
      this.search();
    },
  },
};
</script>

<style lang="scss" scoped>
.public_benefit_index {
  background: #fff;

  .center_block {
    display: block;
    width: 1370px !important;
    margin: 0 auto 150px;
  }

  .header {
    width: 100%;
    height: 495px;
    margin-bottom: 100px;

    .top {
      @include flex();
      position: relative;
      height: 160px;
      box-sizing: border-box;
      padding-top: 17px;
      z-index: 2;
      @include bg("../../assets/img/publicBenefit/top_bg.png");

      .left {
        font-size: 34px;
        font-family: PangMenZhengDao;
        font-weight: 400;
        color: #cc1a30;
        position: absolute;
        top: 30px;
        left: 62px;
      }

      .center {
        @include flex(column, flex-start, center);

        .logo {
          width: 63px;
          height: 63px;
          @include bg("../../assets/img/publicBenefit/logo.png");
        }

        .title {
          font-size: 48px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #373737;
          margin-top: 12px;
          margin-bottom: 22px;
        }
      }
    }

    .content {
      margin-top: -70px;
      width: 100%;
      height: 370px;
      @include bg("../../assets/img/publicBenefit/other_banner.jpg");
      @include flex(column);
      box-sizing: border-box;
      padding: 110px 0 55px;
      font-size: 30px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: #ffffff;
      line-height: 48px;

      .title_top {
        font-size: 40px;
        margin-bottom: 40px;
      }
    }
  }

  .video_title_block {
    width: 1440px;
    margin: 0 auto 69px;
    @include flex(row, space-between, center);

    .title_component {
      width: 400px;
      @include flex(row, flex-start, center);
      color: #228ded;

      .title {
        font-weight: bold;
        padding: 0 10px;
        font-size: 39px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #3565b5;
      }

      .bar_one {
        width: 4px;
        height: 19px;
        background: #3565b5;
      }

      .bar_two {
        width: 4px;
        height: 24px;
        margin: 0 5px;
        background: #3565b5;
      }

      .text {
        font-size: 24px;
        font-weight: 700;
        padding: 0 20px;
        line-height: 30px;
      }
    }

    .btns {
      @include flex(row, flex-end, center);

      .search {
        width: 204px;
        height: 35px;
        border: 1px solid #3565b5;
        border-radius: 18px;
        box-sizing: border-box;
        padding: 0 37px 0 23px;
        position: relative;

        input {
          width: 100%;
          font-size: 14px;
        }

        .icon {
          display: block;
          width: 19px;
          height: 19px;
          position: absolute;
          top: 8px;
          right: 18px;
          @include bg("../../assets/img/publicBenefit/search.png");
          cursor: pointer;
        }
      }

      .upload {
        width: 151px;
        height: 35px;
        background: #3565b5;
        border-radius: 18px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        margin: 0 0 0 10px;
        @include flex();
      }
    }
  }

  .video_block {
    width: 1479px;
    margin: 0 auto;
    margin-bottom: 93px;
    position: relative;
    left: 19.5px;

    .video_block_item {
      width: 260px;
      height: 147px;
      margin-bottom: 11px;
      margin-right: 39px;
      border-radius: 10px;
      overflow: hidden;
      float: left;

      .video_player_block {
        width: 100%;
        height: 100%;
        position: relative;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        img {
          width: 100%;
          height: 100%;
          background: transparent;
        }

        .icon {
          width: 70px;
          height: 29px;
          background: #cc1a30;
          text-align: center;
          line-height: 29px;
          font-size: 18px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #ffffff;
          position: absolute;
          top: 0;
          right: 0;
        }

        .player_icon {
          width: 53px;
          height: 53px;
          @include bg("../../assets/img/publicBenefit/player.png");
          position: absolute;
          top: 47px;
          left: 107px;
        }

        .alert_info {
          @include flex(row, flex-start, center);
          font-size: 20px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #ffffff;
          position: absolute;
          left: 0;
          bottom: 10px;
          display: none;

          .eye {
            margin-left: 13px;
            @include flex(row, flex-start, center);

            .eye_icon {
              width: 18px;
              height: 14px;
              margin-right: 4px;
              @include bg("../../assets/img/publicBenefit/eye.png");
            }
          }

          .msg {
            margin-left: 12px;
            @include flex(row, flex-start, center);

            .msg_icon {
              width: 21px;
              height: 21px;
              margin-right: 1px;
              @include bg("../../assets/img/publicBenefit/message.png");
            }
          }
        }

        .fire {
          display: none;
          width: 34px;
          height: 47px;
          @include bg("../../assets/img/publicBenefit/fire.png");
          position: absolute;
          bottom: 12px;
          right: 18px;
        }

        .title {
          position: absolute;
          font-size: 15px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #ffffff;
          left: 12px;
          bottom: 11px;
          @include text-hid();
        }
      }

      .hover {
        width: 100%;
        height: 100%;
      }

      .hover:hover {
        background-color: rgba(0, 0, 0, 0.7);

        .alert_info {
          display: flex;
          background: transparent;
        }

        .title {
          top: 9px;
          left: 11px;
          background: transparent;
        }
      }
    }

    .video_block_item:nth-child(7n + 1) {
      width: 539px;
      height: 304px;

      .player_icon {
        width: 109px;
        height: 109px;
        top: 98px;
        left: 217px;
        background-color: transparent;
      }

      .fire {
        display: block;
        background-color: transparent;
      }

      .hover:hover {
        .alert_info {
          display: flex;

          .eye {
            margin-left: 25px;

            .eye_icon {
              width: 37px;
              height: 29px;
              margin-right: 9px;
            }
          }

          .msg {
            margin-left: 28px;

            .msg_icon {
              width: 34px;
              height: 34px;
              margin-right: 7px;
            }
          }
        }

        .title {
          top: 18px;
          left: 23px;
          font-size: 30px;
          background: transparent;
        }

        .fire {
          background-color: transparent;
        }
      }
    }

    .video_block_item:first-child {
      width: 539px;
      height: 304px;

      .alert_info {
        left: 0;
        bottom: 18px;
      }

      .player_icon {
        width: 109px;
        height: 109px;
        top: 98px;
        left: 217px;
        background-color: transparent;
      }

      .hover:hover {
        .alert_info {
          display: flex;

          .eye {
            margin-left: 25px;

            .eye_icon {
              width: 37px;
              height: 29px;
              margin-right: 9px;
            }
          }

          .msg {
            margin-left: 28px;

            .msg_icon {
              width: 34px;
              height: 34px;
              margin-right: 7px;
            }
          }
        }

        .title {
          top: 18px;
          left: 23px;
          font-size: 30px;
          background: transparent;
        }

        .fire {
          background-color: transparent;
        }
      }
    }
  }

  .video_block::after {
    content: "";
    display: block;
    height: 0;
    clear: both;
  }

  .bottom_more {
    width: 31px;
    height: 40px;
    @include bg("../../assets/img/publicBenefit/more.png");
    margin: 0 auto 160px;
  }

  .btns {
    width: 100%;
    @include flex();

    div {
      width: 247px;
      height: 66px;
      background: #ffffff;
      border: 2px solid #3565b5;
      border-radius: 20px;
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #3565b5;
      margin: 0 21.5px;
      @include flex();
    }
  }

  .tabmore {
    width: 151px;
    height: 35px;
    background: #3565b5;
    border-radius: 18px;
    font-size: 19px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    line-height: 35px;
    position: absolute;
    top: -61px;
    right: 19px;
  }

  .alert_block {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.2);
    @include flex();

    .block {
      width: 1112px;
      height: 578px;
      background: #ffffff;
      box-shadow: 0px 0px 30px 2px rgba(0, 0, 0, 0.07);
      border-radius: 20px;
      position: relative;
      @include flex();

      .left {
        width: 315px;
        height: 454px;
        @include flex();
        border-right: 3px solid #d1d0d0;

        .dot {
          width: 177px;
          height: 177px;
          background: #f5f5f5;
          border-radius: 50%;
          @include flex();
          @include bg("../../assets/img/publicBenefit/upload_icon.png");
          background-size: auto;
        }
      }

      .right {
        flex: 1;

        .check_list {
          width: 100%;
          @include flex();
          margin-bottom: 68px;

          input {
            margin-right: 5px;
          }

          label {
            margin-right: 68px;
            font-size: 32px;
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
            color: #333333;
          }

          label:last-child {
            margin-right: 0;
          }
        }

        .other_upload_block,
        .file_upload_block {
          padding-left: 50px;

          div {
            margin-bottom: 22px;
            @include flex(row, flex-start, flex-start);

            .btn {
              font-size: 30px;
              font-family: Alibaba PuHuiTi;
              font-weight: bold;
              color: #ffffff;
              width: 210px;
              height: 44px;
              box-sizing: border-box;
              background: #3565b5;
              border-radius: 20px;
              @include flex();
              margin-bottom: 0;
              margin-right: 19px;
            }

            input {
              width: 308px;
              height: 41px;
              border: 1px solid #3565b5;
              border-radius: 20px;
              padding-left: 10px;
            }
          }
        }

        .other_upload_block {
          .list {
            width: 520px;
            @include flex(row, flex-start, center);

            .item {
              width: 113px;
              height: 108px;
              margin-right: 10px;
              border: 1px solid #f5f5f5;
              position: relative;

              img {
                width: 100%;
                height: 100%;
              }

              .del_icon {
                width: 20px;
                height: 20px;
                position: absolute;
                @include bg("../../assets/img/publicBenefit/del.png");
                top: -10px;
                right: -10px;
                border: 1px solid #000;
                border-radius: 50%;
              }
            }

            .item:last-child {
              margin-bottom: 0;
            }

            .default {
              border: none;
              @include bg("../../assets/img/publicBenefit/add.png");
            }
          }
        }

        .submit {
          width: 167px;
          height: 49px;
          background: #3565b5;
          border-radius: 10px;
          @include flex();
          font-size: 32px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #ffffff;
          margin-left: 370px;
        }
      }

      .del {
        width: 23px;
        height: 23px;
        position: absolute;
        @include bg("../../assets/img/publicBenefit/del.png");
        top: 27px;
        right: 33px;
      }
    }

    .upload_btn {
      font-size: 30px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: #ffffff;
      width: 150px;
      height: 44px;
      box-sizing: border-box;
      background: #3565b5 !important;
      border-radius: 20px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 0;
      margin-left: 19px;
    }
  }

  .tab_list {
    width: 1440px;
    margin: 0 auto 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .center_block {
    display: block;
    width: 1440px !important;
    margin: 0 auto 150px;
  }

  .tab_list .tab_list_block {
    width: 345px;
    height: 172px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    padding-top: 26px;
    top: -82px;
    cursor: pointer;
  }

  .tab_list .tab_list_block .training_icon {
    width: 80px;
    height: 66px;
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,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);
  }

  .tab_list .tab_list_block .title {
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    margin-top: 10px;
  }

  .tab_list .tab_list_block .lecture_icon {
    width: 66px;
    height: 66px;
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,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);
  }

  .tab_list .tab_list_block .test_icon {
    width: 70px;
    height: 64px;
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,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);
  }

  .tab_list .tab_list_block .sports_icon {
    width: 74px;
    height: 64px;
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,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);
  }

  .tab_list .tab_list_block:hover {
    top: -100px;
  }

  .training {
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url("../../assets/img/publicBenefit/bg1.png");
  }

  .lecture {
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url("../../assets/img/publicBenefit/bg2.png");
  }

  .test {
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url("../../assets/img/publicBenefit/bg3.png");
  }

  .sports {
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url("../../assets/img/publicBenefit/bg4.png");
  }
}
</style>
<style lang="scss">
// .public_benefit_index {
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

// }
</style>
